module.exports = new __parcel__URL__("feature-6.e0fe1088.png").toString();